module.exports = __webpack_public_path__ + "img/ArtyTechnologyGris.dc6842f6.png";